import { Suspense, lazy } from 'react'
import { Outlet } from 'react-router-dom'

import Nav from './Nav'
import NotificationBanner from './NotificationBanner'

// Lazy load Footer - it's below the fold and not needed for initial render
const Footer = lazy(() => import('./Footer'))

function Layout () {
  return (
    <div className="App">
      <h1 className="silent">Brazilian Jiu-Jitsu Classes in Lake Oswego, Oregon.  BJJ near me in Lake Oswego , Oregon.</h1>
      <Nav />
      <NotificationBanner />
      <main>
        <Outlet />
      </main>
      <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
        <Footer />
      </Suspense>
    </div>
  )
}

export default Layout
